<div class="container">
  <header class="page_header">
    <div class="header_content">
      <div class="text_and_supporting_text">
        <div class="page_title">User Management</div>
        <!-- <div class="page_desc">View and manage the list of Users</div> -->
      </div>
      <div class="action_btn">
        <button class="add_new_btn" (click)="addNewRecord()" *RequiresPermission="{permissionIds: [PermissionConstants.USERS.CREATE],type: 'any'}">
          <img src="assets/icons/plus_icon.svg" height="20" width="20">Add New
        </button>
      </div>
    </div>
  </header>


  <app-tos-table
    *RequiresPermission="{permissionIds: [PermissionConstants.USERS.LIST]}; fallback: true"
    [stats]="tableStats"
    [showTableStats]="true"
    [searchBarConfig]="searchBarConfig"
    [filterConfig]="{
      useNewContract: true,
      filterFields: userFilterConfig.filterFields
    }"
    [tableMeta]="tableMeta"
    [tableMenuOptions]="menuOptions"
    [(dataListRequest)]="tableListRequest"
    [dataListResponse]="tableListData"
    [(selectedItems)]="selectedItems"
    (tosTableAction)="getTableList()"
    (tableMenuOptionSelected)="handleOptionSelected($event)"
  ></app-tos-table>
</div>

